import React from 'react';

function RequestsTable({ requests, loading, onRefresh, onViewRequest, lastRefresh }) {
  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
      case 'pending':
        return 'status-submitted';
      case 'processing':
      case 'fuzzy-match-found':
      case 'no-fuzzy-match':
      case 'gpt4-adapted':
      case 'custom-translated':
        return 'status-processing';
      case 'completed':
        return 'status-completed';
      case 'error':
        return 'status-error';
      default:
        return 'status-submitted';
    }
  };

  const getTypeClass = (type) => {
    switch (type?.toLowerCase()) {
      case 'exact':
        return 'type-exact';
      case 'fuzzy-adapted':
      case 'fuzzy':
        return 'type-fuzzy-adapted';
      case 'custom':
        return 'type-custom';
      default:
        return '';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '-';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="card">
      <h2 className="card-title">Translation Requests</h2>

      <div className="refresh-bar">
        <span className="refresh-info">
          {lastRefresh ? (
            <>Last refreshed: {lastRefresh.toLocaleTimeString()}</>
          ) : (
            'Not yet loaded'
          )}
          {' · '}{requests.length} requests
        </span>
        <button
          className="btn btn-secondary btn-small"
          onClick={onRefresh}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner"></span>
              Refreshing...
            </>
          ) : (
            '↻ Refresh'
          )}
        </button>
      </div>

      {requests.length === 0 && !loading ? (
        <div className="empty-state">
          <div className="empty-state-icon">📝</div>
          <p>No translation requests yet.</p>
          <p>Submit a translation request to get started.</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Request ID</th>
                <th>Source (English)</th>
                <th>Target (Spanish)</th>
                <th>Type</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request.req_id}>
                  <td>
                    <code style={{ fontSize: '0.75rem' }}>
                      {request.req_id?.substring(0, 8)}...
                    </code>
                  </td>
                  <td className="text-wrap">
                    {truncateText(request.source || request.English, 60)}
                  </td>
                  <td className="text-wrap">
                    {truncateText(request.target || request.Spanish, 60)}
                  </td>
                  <td>
                    {request.translation_type ? (
                      <span className={`type-badge ${getTypeClass(request.translation_type)}`}>
                        {request.translation_type}
                      </span>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <span className={`status-badge ${getStatusClass(request.status)}`}>
                      {request.status || 'pending'}
                    </span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}>
                    {formatDate(request.received_date)}
                  </td>
                  <td>
                    <div className="actions">
                      <button
                        className="btn btn-primary btn-small"
                        onClick={() => onViewRequest(request)}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default RequestsTable;
